import api from '@/apis'
import router from '@/router'
import Vuetify from '@/plugins/vuetify'
const lang = Vuetify.locale

// Every device picker (left bar, chat, conversation check) reads auth.device_list, so order it alphabetically once here.
const sortDevicesByDescription = (devices) => [...devices].sort((a, b) => (a.description || '').localeCompare(b.description || '', undefined, { numeric: true, sensitivity: 'base' }))

export default {
  state: {
    status: false,
    user_info: {},
    access_token: null,
    auth_project_id: null,
    page_access: [],
    privileges: {},
    device_list: [],
    selected_device: null
  },
  mutations: {
    SET_AUTH_INFO(state, { access_token, auth_project_id, user_info, page_access, privileges }) {
      state.access_token = access_token
      state.auth_project_id = auth_project_id
      state.user_info = user_info
      state.page_access = page_access && page_access.length ? page_access : 'all'
      state.privileges = privileges
    },
    SET_AUTH_DEVICE_LIST(state, payload) {
      state.device_list = payload
    },
    SET_AUTH_SELECTED_DEVICE(state, payload) {
      state.selected_device = payload
    },
    INIT_AUTH_STATUS(state) {
      state.status = true
    },
    RESET_AUTH_STATUS(state) {
      state.access_token = null
      state.auth_project_id = null
      state.user_info = {}
      state.page_access = []
      state.status = false
      router.push({ path: '/login' })
    }
  },
  actions: {
    async authenticate({ commit }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: lang.t('$vuetify.__SnackBar.authenticating'), loading: true })
        const response = await api.login(payload)
        if (response.data.success) {
          const { access_token, auth_project_id, page_access, privileges } = response.data.data
          commit('SET_AUTH_INFO', { user_info: response.data.data, access_token, auth_project_id, page_access, privileges })
          commit('SET_SNACKBAR', { status: true, color: 'loading', text: lang.t('$vuetify.__SnackBar.device_list'), loading: true })
          const device_list = await api.getDeviceList({ project_id: response.data.data.project_id })
          if (device_list.data.success) {
            const devices = sortDevicesByDescription(device_list.data.data)
            if (response.data.data.is_password_expired) {
              commit('SET_AUTH_SELECTED_DEVICE', devices.length ? devices[0].id : null)
              await commit('INIT_USER_MNGT_DIALOG', {
                mode: 'reset',
                user: {
                  user_id: response.data.data.user_id,
                  username: response.data.data.username,
                  role_id: response.data.data.role_id
                }
              })
              commit('SET_SNACKBAR', {
                status: true,
                color: 'success',
                text: 'Reset Password',
                icon: 'check',
                timeout: '2000'
              })
            } else {
              if (device_list.data.success) {
                commit('SET_SNACKBAR', {
                  status: true,
                  color: 'success',
                  text: lang.t('$vuetify.__SnackBar.success', lang.t('$vuetify.__Login.login')),
                  icon: 'check',
                  timeout: '2000'
                })
                commit('SET_AUTH_DEVICE_LIST', devices)
                commit('SET_AUTH_SELECTED_DEVICE', devices.length ? devices[0].id : null)
                commit('INIT_AUTH_STATUS')
                router.push({ path: '/dashboard' })
              }
            }
          } else throw Error(device_list.data.message)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    logout({ state, commit }) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: lang.t('$vuetify.__SnackBar.logging_out'), loading: true })
        api.logout({ params: { access_token: state.access_token } })
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('RESET_AUTH_STATUS')
        commit('SET_SNACKBAR', {
          status: true,
          color: 'success',
          text: lang.t('$vuetify.__SnackBar.success', lang.t('$vuetify.__LeftBar.logout')),
          icon: 'check',
          timeout: '2000'
        })
      }
    }
  }
}
